export default "__VITE_ASSET__0807aa01__"